/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_PLATFORMJK} from '../../../constans';
import {RSAA} from 'redux-api-middleware';
import headers from "../../../utils/headers";
import {
    GET_LIST_POST_FANPAGE_V2_REQUEST,
    GET_LIST_POST_FANPAGE_V2_SUCCESS,
    GET_LIST_POST_FANPAGE_V2_FAILURE
} from "../../../types";
import queryString from "query-string";

const GetListPostOfFanpageAction = (fanpageId = 0, limit = 100, page = 1, sort = "-created_at") => ({

    [RSAA]: {
        endpoint: () => {
            let parsed = {
                'limit': limit,
                'page': page,
                'sort': sort
            };
            let query_param = queryString.stringify(parsed);
            return `${SERVER_API_PLATFORMJK}/api/pages/${fanpageId}/posts?${query_param}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            GET_LIST_POST_FANPAGE_V2_REQUEST,
            {
                type: GET_LIST_POST_FANPAGE_V2_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data;
                    });

                    return {
                        "code": 0,
                        "type": GET_LIST_POST_FANPAGE_V2_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: GET_LIST_POST_FANPAGE_V2_FAILURE,
                payload: async (action, state, res) => {
                    let message = "";

                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GET_LIST_POST_FANPAGE_V2_FAILURE,
                        "message": message,
                        "data": [],
                    }
                },
            },
        ]
    }

});

export {GetListPostOfFanpageAction}